/**
 * Checks for WebP support via a Canvas element check.
 * You should never be using this function directly as it takes time to run
 * Instead use the cached response `isWebpSupported`
 * https://stackoverflow.com/a/27232658/493034
 *
 * Exported for testing
 */
export function _checkWebpSupport() {
  const elem = document.createElement('canvas');

  if (!!(elem.getContext && elem.getContext('2d'))) {
      // was able or not to get WebP representation
      return elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
  }

  // very old browser like IE 8, canvas not supported
  return false;
}

export const isWebpSupported = _checkWebpSupport();
